// extracted by mini-css-extract-plugin
export default {"banner":"appInfoBanner_banner__9eyNI"};